module.exports = __webpack_public_path__ + "static/media/smhc_logo.4fcbc25f.png";